import { createAction } from '../../../core/helpers'

import { FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES } from '../action-types'

const cleanupFetchIngredientCommonNegativeSynonymPhrases = createAction(
  FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.CLEANUP,
)

export default cleanupFetchIngredientCommonNegativeSynonymPhrases
